export default __webpack_public_path__ + "static/media/Wordpress.d618ff9b.svg";